<template>
  <div class="hello">

    <b-container>

        <div v-if ="getCartSize" >
            <b-row style="margin-top:10px">
            <b-col>
                <b-button @click="gotToCart()" variant="info"> Go To Cart </b-button>
            </b-col>
        </b-row>
        
            <template  v-for="(item) in userCart" >
                <hr :key="item.suborderid+'hr'">
                <b-row :key="item.suborderid+'brewer'">
                    <!-- Image -->
                    <b-col cols="4">
                        <div v-if="item.beerLogoURL" style="width:50px; text-align: center">
                            <img :src="item.beerLogoURL" width="50" fluid alt="Logo image"
                            >
                        </div>
                        <div v-else style="height:75px; text-align: center">
                            <img src="https://res.cloudinary.com/lo4xxr5lr/image/upload/v1574513408/stock/beer.jpg" height="75" fluid alt="Logo image">
                        </div>
                    </b-col>
                    <!-- Other info -->
                    <b-col>
                        <b-container>
                            <b-row>
                                <b-col>
                                    <div class="breweryname" style=""><h6>{{item.brewer}}</h6></div>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col>
                                    <div style="">{{item.beerName}}</div>
                                </b-col>
                            </b-row>
                        </b-container>

                    </b-col>
                    
                </b-row>
                <b-row :key="item.suborderid+'size'" style="margin-top:10px">
                    <b-col style="font-size:12px">{{item.size}}</b-col>
                    <b-col cols='3'><div style="color:green">${{item.cost}}</div></b-col>
                </b-row>

                
            </template>
        </div>

        <b-row style="margin-top:10px">
            <b-col>
                <b-button @click="gotToCart()" variant="info"> Go To Cart </b-button>
            </b-col>
        </b-row>


    </b-container>
      
  </div>
</template>

<script>

import { mapState } from 'vuex'

export default {    
    props: {
    },

    computed: {
        ...mapState(['userProfileStatus', 'userProfile', 'currentUser', 'userCart']),
        getCartSize(){
                return this.userCart.length
            },
    },

    components: {
    },

    data() {
        return {

        }
    },

    methods:{
        pageChanged(){
        },
        getImageSource(beer){
            console.log("Getting image source for ")
            console.log(beer)
                //return {"uri": this.navigation.getParam("beer").logoFileThumbnailURL}
                if(beer.beerLogoURL) return beer.beerLogoURL
                else if (beer.logoFileThumbnailURL) return  beer.logoFileThumbnailURL
                else return require('../../assets/beer.jpg')
        },

        //Go to cart
        gotToCart(){
            this.$router.push({ name: 'cart'})
        },

        closeSidebar(){
            this.$parent.hideCartSidebar()
        },
    },

    mounted(){
    },
}
</script>

